import { Injectable } from '@angular/core';
import {trigger} from "@angular/animations";
@Injectable({
    providedIn: 'root'
})
export class NodeService {
    getTreeNodesData() {
        return [
            {
                key: '0',
                label: 'Documents',
                data: 'Documents Folder',
                icon: 'pi pi-fw pi-inbox',
                children: [
                    {
                        key: '0-0',
                        label: 'Work',
                        data: 'Work Folder',
                        icon: 'pi pi-fw pi-cog',
                        children: [
                            { key: '0-0-0', label: 'Expenses.doc', icon: 'pi pi-fw pi-file', data: 'Expenses Document' },
                            { key: '0-0-1', label: 'Resume.doc', icon: 'pi pi-fw pi-file', data: 'Resume Document' }
                        ]
                    },
                    {
                        key: '0-1',
                        label: 'Home',
                        data: 'Home Folder',
                        icon: 'pi pi-fw pi-home',
                        children: [{ key: '0-1-0', label: 'Invoices.txt', icon: 'pi pi-fw pi-file', data: 'Invoices for this month' }]
                    }
                ]
            },
            {
                key: '1',
                label: 'Events',
                data: 'Events Folder',
                icon: 'pi pi-fw pi-calendar',
                children: [
                    { key: '1-0', label: 'Meeting', icon: 'pi pi-fw pi-calendar-plus', data: 'Meeting' },
                    { key: '1-1', label: 'Product Launch', icon: 'pi pi-fw pi-calendar-plus', data: 'Product Launch' },
                    { key: '1-2', label: 'Report Review', icon: 'pi pi-fw pi-calendar-plus', data: 'Report Review' }
                ]
            },
            {
                key: '2',
                label: 'Movies',
                data: 'Movies Folder',
                icon: 'pi pi-fw pi-star-fill',
                children: [
                    {
                        key: '2-0',
                        icon: 'pi pi-fw pi-star-fill',
                        label: 'Al Pacino',
                        data: 'Pacino Movies',
                        children: [
                            { key: '2-0-0', label: 'Scarface', icon: 'pi pi-fw pi-video', data: 'Scarface Movie' },
                            { key: '2-0-1', label: 'Serpico', icon: 'pi pi-fw pi-video', data: 'Serpico Movie' }
                        ]
                    },
                    {
                        key: '2-1',
                        label: 'Robert De Niro',
                        icon: 'pi pi-fw pi-star-fill',
                        data: 'De Niro Movies',
                        children: [
                            { key: '2-1-0', label: 'Goodfellas', icon: 'pi pi-fw pi-video', data: 'Goodfellas Movie' },
                            { key: '2-1-1', label: 'Untouchables', icon: 'pi pi-fw pi-video', data: 'Untouchables Movie' }
                        ]
                    }
                ]
            }
        ];
    }

    getTreeTableNodesData() {
        return [
            {
                key: '0',
                data: {
                    name: 'Home',
                    size: '100kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '0-0',
                        data: {
                            name: 'React',
                            size: '25kb',
                            type: 'Folder'
                        },
                        children: [
                            {
                                key: '0-0-0',
                                data: {
                                    name: 'react.app',
                                    size: '10kb',
                                    type: 'Application'
                                }
                            },
                            {
                                key: '0-0-1',
                                data: {
                                    name: 'native.app',
                                    size: '10kb',
                                    type: 'Application'
                                }
                            },
                            {
                                key: '0-0-2',
                                data: {
                                    name: 'mobile.app',
                                    size: '5kb',
                                    type: 'Application'
                                }
                            }
                        ]
                    },
                    {
                        key: '0-1',
                        data: {
                            name: 'editor.app',
                            size: '25kb',
                            type: 'Application'
                        }
                    },
                    {
                        key: '0-2',
                        data: {
                            name: 'settings.app',
                            size: '50kb',
                            type: 'Application'
                        }
                    }
                ]
            },
            {
                key: '1',
                data: {
                    name: 'Requests',
                    size: '20kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '1-0',
                        data: {
                            name: 'backup-1.zip',
                            size: '10kb',
                            type: 'Zip'
                        }
                    },
                    {
                        key: '1-1',
                        data: {
                            name: 'backup-2.zip',
                            size: '10kb',
                            type: 'Zip'
                        }
                    }
                ]
            },
            {
                key: '2',
                data: {
                    name: 'Clients',
                    size: '150kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '2-0',
                        data: {
                            name: 'note-meeting.txt',
                            size: '50kb',
                            type: 'Text'
                        }
                    },
                    {
                        key: '2-1',
                        data: {
                            name: 'note-todo.txt',
                            size: '100kb',
                            type: 'Text'
                        }
                    }
                ]
            },
            {
                key: '3',
                data: {
                    name: 'Agencies',
                    size: '75kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '3-0',
                        data: {
                            name: 'Work',
                            size: '55kb',
                            type: 'Folder'
                        },
                        children: [
                            {
                                key: '3-0-0',
                                data: {
                                    name: 'Expenses.doc',
                                    size: '30kb',
                                    type: 'Document'
                                }
                            },
                            {
                                key: '3-0-1',
                                data: {
                                    name: 'Resume.doc',
                                    size: '25kb',
                                    type: 'Resume'
                                }
                            }
                        ]
                    },
                    {
                        key: '3-1',
                        data: {
                            name: 'Home',
                            size: '20kb',
                            type: 'Folder'
                        },
                        children: [
                            {
                                key: '3-1-0',
                                data: {
                                    name: 'Invoices',
                                    size: '20kb',
                                    type: 'Text'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                key: '4',
                data: {
                    name: 'Settings',
                    size: '25kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '4-0',
                        data: {
                            name: 'Spanish',
                            size: '10kb',
                            type: 'Folder'
                        },
                        children: [
                            {
                                key: '4-0-0',
                                data: {
                                    name: 'tutorial-a1.txt',
                                    size: '5kb',
                                    type: 'Text'
                                }
                            },
                            {
                                key: '4-0-1',
                                data: {
                                    name: 'tutorial-a2.txt',
                                    size: '5kb',
                                    type: 'Text'
                                }
                            }
                        ]
                    },
                    {
                        key: '4-1',
                        data: {
                            name: 'Travel',
                            size: '15kb',
                            type: 'Text'
                        },
                        children: [
                            {
                                key: '4-1-0',
                                data: {
                                    name: 'Hotel.pdf',
                                    size: '10kb',
                                    type: 'PDF'
                                }
                            },
                            {
                                key: '4-1-1',
                                data: {
                                    name: 'Flight.pdf',
                                    size: '5kb',
                                    type: 'PDF'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                key: '5',
                data: {
                    name: 'Administrative',
                    size: '50kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '5-0',
                        data: {
                            name: 'bin',
                            size: '50kb',
                            type: 'Link'
                        }
                    },
                    {
                        key: '5-1',
                        data: {
                            name: 'etc',
                            size: '100kb',
                            type: 'Link'
                        }
                    },
                    {
                        key: '5-2',
                        data: {
                            name: 'var',
                            size: '100kb',
                            type: 'Link'
                        }
                    }
                ]
            }
        ];
    }

    getLazyNodesData() {
        return [
            {
                label: 'Lazy Node 0',
                data: 'Node 0',
                expandedIcon: 'pi pi-folder-open',
                collapsedIcon: 'pi pi-folder',
                leaf: false
            },
            {
                label: 'Lazy Node 1',
                data: 'Node 1',
                expandedIcon: 'pi pi-folder-open',
                collapsedIcon: 'pi pi-folder',
                leaf: false
            },
            {
                label: 'Lazy Node 1',
                data: 'Node 2',
                expandedIcon: 'pi pi-folder-open',
                collapsedIcon: 'pi pi-folder',
                leaf: false
            }
        ];
    }

    getFileSystemNodesData() {
        return [
            {
                key: '0',
                data: {
                    id: 1,
                    name: 'Home',
                    description: 'Navigation for Home / Dashboard and Reports',
                    access: 'No Access',
                    optionReadOnly: false,
                    optionReadWrite: false,
                    optionExecute: true,
                    optionShow: false,
                    type: 'Navigation',
                    usedInMultipleAreas: false,
                    activeStatus: 'Active'
                },
                children: [
                    {
                        key: '0-0',
                        data: {
                            id: 2,
                            name: 'Dashboard Tab',
                            description: 'Shows the dashboard with charts and metric cards',
                            access: 'No Access',
                            optionReadOnly: false,
                            optionReadWrite: false,
                            optionExecute: true,
                            optionShow: false,
                            type: 'Navigation',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        },
                        children: [
                            {
                                key: '0-0-0',
                                data: {
                                    id: 3,
                                    name: 'Metric Cards',
                                    description: 'Shows the metric cards',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            },
                            {
                                key: '0-0-1',
                                data: {
                                    id: 4,
                                    name: 'Dashboard Charts',
                                    description: 'Shows the dashboard charts',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            }
                        ]
                    },
                    {
                        key: '0-1',
                        data: {
                            id: 5,
                            name: 'Repors tab',
                            description: 'Navigation for Reports',
                            access: 'No Access',
                            optionReadOnly: false,
                            optionReadWrite: false,
                            optionExecute: true,
                            optionShow: false,
                            type: 'Navigation',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        }
                    },
                    {
                        key: '0-2',
                        data: {
                            id: 6,
                            name: 'Administrative Reports',
                            description: 'Shows the administrative reports',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        }
                    },
                    {
                        key: '0-2',
                        data: {
                            id: 7,
                            name: 'General Productivity Reports',
                            description: 'Shows the genral productivity reports',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        }
                    }
                ]
            },
            {
                key: '1',
                data: {
                    id: 8,
                    name: 'Requests',
                    description: 'Navigation for Service Requests This is a very long description of what this item' +
                        ' actually relates to - you will need to have special access to see different types of' +
                        ' things underneath it so be very careful on how you apportion these rights: <br />' +
                        ' OK next lets see if this puppy can actually scroll <br /> '+
                        ' <b>Steps to take it down:</b><br />' +
                        ' <i>2. Down - down we go <br />' +
                        ' 3. Down - down we go <br />' +
                        ' 4. Down - down we go <br />' +
                        ' 5. Down - down we go </i><br />' +
                        ' actually relates to - you will need to have special access to see different types of' +
                        ' things underneath it so be very careful on how you apportion these rights: <br />' +
                        ' OK next lets see if this puppy can actually scroll <br /> '+
                        ' Down - down we go <br />',
                    access: 'No Access',
                    optionReadOnly: false,
                    optionReadWrite: false,
                    optionExecute: true,
                    optionShow: false,
                    type: 'Navigation',
                    usedInMultipleAreas: false,
                    activeStatus: 'Active'
                },
                children: [
                    {
                        key: '1-0',
                        data: {
                            id: 9,
                            name: 'Request Details Dialog',
                            description: 'Shows the request details dialog',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        },

                        children: [
                            {
                                key: '1-0-0',
                                data: {
                                    id: 10,
                                    name: 'Request Details Tab',
                                    description: 'Access the <b>Request details</b> information',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                },
                                children: [
                                    {
                                        key: '1-0-0-0',
                                        data: {
                                            id: 11,
                                            name: 'Assign Requests',
                                            description: 'Enables Assign Requests',
                                            access: 'No Access',
                                            optionReadOnly: true,
                                            optionReadWrite: true,
                                            optionExecute: false,
                                            optionShow: false,
                                            type: 'Component',
                                            usedInMultipleAreas: false,
                                            activeStatus: 'Active'
                                        }
                                    },
                                    {
                                        key: '1-0-0-1',
                                        data: {
                                            id: 12,
                                            name: 'Current need field',
                                            description: 'Show the current need field',
                                            access: 'No Access',
                                            optionReadOnly: true,
                                            optionReadWrite: true,
                                            optionExecute: false,
                                            optionShow: false,
                                            type: 'Component',
                                            usedInMultipleAreas: false,
                                            activeStatus: 'Active'
                                        }
                                    }
                                ]
                            },
                            {
                                key: '1-1',
                                data: {
                                    id: 13,
                                    name: 'Global Search',
                                    description: 'Shows the global search',
                                    access: 'No Access',
                                    optionReadOnly: false,
                                    optionReadWrite: false,
                                    optionExecute: false,
                                    optionShow: true,
                                    type: 'Field',
                                    usedInMultipleAreas: true,
                                    activeStatus: 'Active'
                                }
                            }
                        ],
                    }],
            },
            {
                key: '2',
                data: {
                    id: 14,
                    name: 'Clients',
                    description: 'Navigation for Clients / Cases and Deduping',
                    access: 'No Access',
                    optionReadOnly: false,
                    optionReadWrite: false,
                    optionExecute: true,
                    optionShow: false,
                    type: 'Navigation',
                    usedInMultipleAreas: false,
                    activeStatus: 'Active'
                },
                children: [
                    {
                        key: '2-0',
                        data: {
                            id: 15,
                            name: 'Client Details Dialog',
                            description: 'Shows the client details dialog',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        }
                    },
                    {
                        key: '2-1',
                        data: {
                            id: 16,
                            name: 'Global Search',
                            description: 'Shows the global search',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: true,
                            activeStatus: 'Active'
                        }
                    }
                ]
            },
            {
                key: '3',
                data: {
                    id: 17,
                    name: 'Agencies',
                    description: 'Navigation for Agencies / Agency Services etc.',
                    access: 'No Access',
                    optionReadOnly: false,
                    optionReadWrite: false,
                    optionExecute: true,
                    optionShow: false,
                    type: 'Navigation',
                    usedInMultipleAreas: false,
                    activeStatus: 'Active'
                },
                children: [
                    {
                        key: '3-0',
                        data: {
                            id: 18,
                            name: 'Manage Agency Details',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        },
                        children: [
                            {
                                key: '3-0-0',
                                data: {
                                    id: 19,
                                    name: 'Manage Agency Users',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            },
                            {
                                key: '3-0-1',
                                data: {
                                    id: 20,
                                    name: 'Manage Hours of Operation',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            }
                        ]
                    },
                    {
                        key: '3-1',
                        data: {
                            id: 21,
                            name: 'Manage Service Definitions',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        },
                        children: [
                            {
                                key: '3-1-0',
                                data: {
                                    id: 22,
                                    name: 'Manage Service Qualification Records',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                key: '4',
                data: {
                    id: 23,
                    name: 'Settings',
                    description: 'Navigation for Settings and administrative services',
                    access: 'No Access',
                    optionReadOnly: false,
                    optionReadWrite: false,
                    optionExecute: true,
                    optionShow: false,
                    type: 'Navigation',
                    usedInMultipleAreas: false,
                    activeStatus: 'InActive'
                },
                children: [
                    {
                        key: '4-0',
                        data: {
                            id: 24,
                            name: 'Manage Systemwide Agencies',
                            description: 'Manage Systemwide Agencies',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        },

                        children: [
                            {
                                key: '4-0-0',
                                data: {
                                    id: 25,
                                    name: 'Manage Role Types for Agencies',
                                    description: 'This allows for role types to be selectable under agency->users',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            },
                            {
                                key: '4-0-1',
                                data: {
                                    id: 26,
                                    name: 'Manage Contact Information for Agencies',
                                    description: 'This allows management for contact information for Agencies',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            }
                        ]
                    },
                    {
                        key: '4-1',
                        data: {
                            id: 27,
                            name: 'Manage Users ',
                            description: 'Manage Systemwide Users',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        },
                        children: [
                            {
                                key: '4-1-0',
                                data: {
                                    id: 28,
                                    name: 'Manage Invitations',
                                    description: 'Manage Systemwide User-Invitations',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            },
                            {
                                key: '4-1-1',
                                data: {
                                    id: 29,
                                    name: 'Manage User password Reset feature',
                                    description: 'Manage Systemwide User-password Resets',
                                    access: 'No Access',
                                    optionReadOnly: true,
                                    optionReadWrite: true,
                                    optionExecute: false,
                                    optionShow: false,
                                    type: 'Component',
                                    usedInMultipleAreas: false,
                                    activeStatus: 'Active'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                key: '5',
                data: {
                    id: 30,
                    name: 'Administrative',
                    access: 'No Access',
                    optionReadOnly: false,
                    optionReadWrite: false,
                    optionExecute: true,
                    optionShow: false,
                    type: 'Navigation',
                    usedInMultipleAreas: false,
                    activeStatus: 'Active'
                },
                children: [
                    {
                        key: '5-0',
                        data: {
                            id: 31,
                            name: 'Stop and Start the automatch service',
                            description: 'Enables access to manage the automatch service',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        }
                    },
                    {
                        key: '5-1',
                        data: {
                            id: 32,
                            name: 'Stop and Start the autoclose service',
                            description: 'Enables access to manage the autoclose service',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        }
                    },
                    {
                        key: '5-2',
                        data: {
                            id: 33,
                            name: 'Enable / Disable Email services',
                            description: 'Enables access to manage the systemwide email service',
                            access: 'No Access',
                            optionReadOnly: true,
                            optionReadWrite: true,
                            optionExecute: false,
                            optionShow: false,
                            type: 'Component',
                            usedInMultipleAreas: false,
                            activeStatus: 'Active'
                        }
                    }
                ]
            }
        ];
    }

    public getTreeTableNodes() {
        return Promise.resolve(this.getTreeTableNodesData());
    }

    public getTreeNodes() {
        return Promise.resolve(this.getTreeNodesData());
    }

    public getFiles() {
        return Promise.resolve(this.getTreeNodesData());
    }

    public getLazyFiles() {
        return Promise.resolve(this.getLazyNodesData());
    }

    public getFilesystem() {
        return Promise.resolve(this.getFileSystemNodesData());
    }

};
